module.exports = __webpack_public_path__ + "img/矩形 2@3x.1217f60c.png";